// extracted by mini-css-extract-plugin
module.exports = {"linksBox":"friendlink-module--linksBox--3_Xwa","links":"friendlink-module--links--2C_Ev","aBox":"friendlink-module--a-box--14iMQ"};